import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment as env } from "../../../environments/environment";
import { StorageService } from '../../shared/services/storage.service';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [NgFor],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss'
})
export class LanguageSwitcherComponent {
  languages = [
    { code: 'ru', name: 'Русский' },
    { code: 'it', name: 'Italiano' }
  ];

  constructor(private translate: TranslateService) {
    const language = env?.defaultLanguage ?? 'it';
    if (language === 'it') {
      this.languages.reverse()
    }
    this.translate.setDefaultLang(language);
    translate.use(language);
    localStorage.setItem("language-locale", JSON.stringify(language))
  }

  switchLanguage(event: Event): void {
    const selectElement = event.target as HTMLSelectElement; // Cast esplicito
    const selectedLang = selectElement.value;
    this.translate.use(selectedLang);
    localStorage.setItem("language-locale", JSON.stringify(selectedLang))
  }
}
